import { render, staticRenderFns } from "./EscalationToSetting.vue?vue&type=template&id=637a8052&scoped=true"
import script from "./EscalationToSetting.vue?vue&type=script&lang=js"
export * from "./EscalationToSetting.vue?vue&type=script&lang=js"
import style0 from "./EscalationToSetting.vue?vue&type=style&index=0&id=637a8052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637a8052",
  null
  
)

export default component.exports